import Bugsnag from '@bugsnag/browser';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import { Echo, MomentoConnector, NoopConnector } from '@voxie/echo';
import { momentoAuthorizer } from '../utils/helpers';
import eventBus from './eventBus';

/**
 * Include static assets referenced directly from Blade templates.
 */
import.meta.glob(['../../img/**'], { eager: true });

window.Bus = eventBus;

const initializeBugsnag = () => {
    if (!window.bugsnagApiKey) {
        return null;
    }

    Bugsnag.start({
        autoTrackSessions: false,
        apiKey: window.bugsnagApiKey,
        appVersion: window.bugsnagAppVersion,
        plugins: [new BugsnagPluginVue()],
        releaseStage: window.appEnvironment,
    });

    if (window.bugsnagUser) {
        // IP is collected by default
        Bugsnag.setUser(window.bugsnagUser.id, window.bugsnagUser.email, window.bugsnagUser.name);

        if (window.bugsnagCurrentTeam) {
            Bugsnag.addMetadata('team', {
                id: window.bugsnagCurrentTeam.id,
                name: window.bugsnagCurrentTeam.name,
            });
        }
    }

    document.addEventListener('securitypolicyviolation', (cspEvent) => {
        // Ignore CSP errors caused by extensions.
        // Those errors mean the extension does not support websites that have CSP header.
        if ((cspEvent.sourceFile || '').startsWith('moz-extension')) {
            return;
        }

        // Sample at 1% to reduce noise in Bugsnag
        if (Math.random() > 0.01) {
            return;
        }

        Bugsnag.notify(new Error('Content-Security-Policy violation occurred'), (event) => {
            event.addMetadata('CSP Event', {
                blockedURI: cspEvent.blockedURI,
                documentURI: cspEvent.documentURI,
                effectiveDirective: cspEvent.effectiveDirective,
                originalPolicy: cspEvent.originalPolicy,
                sourceFile: cspEvent.sourceFile,
                violatedDirective: cspEvent.violatedDirective,
            });
        });
    });

    window.Bugsnag = Bugsnag;

    return Bugsnag.getPlugin('vue');
};

const createEchoConnector = () => {
    const cache = window.momentoCacheName;

    if (!cache) {
        return new NoopConnector();
    }

    return new MomentoConnector({
        cache,
        namespace: 'App.Events',
        authorizer: momentoAuthorizer,
        healthCheckDelay: 5000,
        logger: window.appEnvironment === 'sandbox' ? window.console : undefined,
    });
};

const bugsnagVue = initializeBugsnag();

window.Echo = new Echo(createEchoConnector());

export { bugsnagVue };
